export const FETCH_CITIES_START = 'FETCH_CITIES_START';
export const FETCH_CITIES_SUCCESS = 'FETCH_CITIES_SUCCESS';
export const FETCH_CITIES_FAILURE = 'FETCH_CITIES_FAILURE';
export const SET_CITIES_FILTER = 'SET_CITIES_FILTER';
export const RESET_CITIES_FILTER = 'RESET_CITIES_FILTER';